define('common/formatter',[
],
    function () {

        var spinnerShownAt = {};

        function money(someNumber, hideZeroAmount) {
            try {
                if (hideZeroAmount && someNumber == 0) return "";
                if (CP.SessionContext.SiteName === "cpuk") {
                    var fmtUK = new Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: 'GBP'
                    });
                    return fmtUK.format(someNumber).replace(".00", "");
                }
                if (CP.SessionContext.SiteName === "cpde") {
                    var fmtDE = new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR'
                    });
                    return fmtDE.format(someNumber).replace(",00", "");
                }
            }
            catch (error) {
                return someNumber;
            }
        }

        return {
            money: money
        };
    });

